import { createTheme } from "@miplatform/theme";
import { ThemeProvider } from "@mui/material/styles";
import { render } from "@testing-library/react";

const theme = createTheme();

const MockTheme = ({ children }) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

const customRender = (ui, options = {}) =>
  render(ui, { wrapper: MockTheme, ...options });

export { customRender as render };
